import { GetWorkspaceBySlugResult } from '@indigohive/cogfy-types/endpoints/getWorkspaceBySlug'
import { ClipboardIcon } from 'lucide-react'
import { useState } from 'react'

export type WorkspaceIdProps = {
  workspace: GetWorkspaceBySlugResult
}

export function WorkspaceId (props: WorkspaceIdProps) {
  const { workspace } = props

  const [recentlyCopiedWorkspaceId, setRecentlyCopiedWorkspaceId] = useState(false)

  const handleCopyWorkspaceId = () => {
    setRecentlyCopiedWorkspaceId(true)

    navigator.clipboard.writeText(workspace.id)

    setTimeout(() => {
      setRecentlyCopiedWorkspaceId(false)
    }, 2000)
  }

  return (
    <>
      <div className='flex flex-col gap-6'>
        <span className='font-bold'>Workspace Id</span>
        <span className="flex items-center text-sm">
          <span className="opacity-70">
            {workspace.id}
          </span>
          <div
            className="tooltip"
            data-tip={recentlyCopiedWorkspaceId ? 'Copied!' : 'Copy workspace id'}
          >
            <button
              className="btn btn-circle btn-ghost btn-xs ml-1 opacity-70"
              onClick={handleCopyWorkspaceId}
            >
              <ClipboardIcon size={16} />
            </button>
          </div>
        </span>
      </div>
    </>
  )
}
